const API_BASE_HOST = 'https://music-api.casioonline.com.cn'
//const API_BASE_HOST = 'https://music-stage.casioonline.com.cn'
//const API_BASE_HOST = 'https://stage-music-api.casioonline.com.cn'
// const API_BASE_HOST = 'http://192.168.130.25:8018'
// const API_BASE_HOST = 'http://localhost:8000'
// const API_BASE_HOST = 'http://127.0.0.1:8005'
export default {
  title: '后台管理系统',

  api: {
    // baseURL: 'http://localhost:8000/admin',
    // baseURL: 'https://stage-music-api.casioonline.com.cn/admin',
    // baseURL: 'http://192.168.2.81:55555/admin'
    //  baseURL: 'https://music-api.casioonline.com.cn/admin',
    baseURL: API_BASE_HOST + '/admin',
  },
  upload: {
    url: API_BASE_HOST + '/admin/upload',
    image: {
      limit: 1024 * 1024 * 50,
      allow: ['jpg', 'jpeg', 'png'],
      accept: 'image/jpg, image/jpeg, image/png',
      tips: '图片格式支持：png,jpeg,jpg；不可大于50M；建议使用png格式图片，以保持最佳效果；'
    },
    video: {
      limit: 1024 * 1024 * 50,
      allow: ['mp4'],
      accept: 'video/mp4',
      tips: '视频格式支持：mp4；不可大于50M；'
    }
  }
}
